import { render, staticRenderFns } from "./ProblemGamblingServiceDelivery.vue?vue&type=template&id=03a233b4&"
import script from "./ProblemGamblingServiceDelivery.vue?vue&type=script&lang=js&"
export * from "./ProblemGamblingServiceDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports